/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Preview_KickerInputs */

const en_platform_preview_kicker = /** @type {(inputs: Platform_Preview_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule`)
};

const pl_platform_preview_kicker = /** @type {(inputs: Platform_Preview_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafik`)
};

/**
* | output |
* | --- |
* | "Schedule" |
*
* @param {Platform_Preview_KickerInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_preview_kicker = /** @type {((inputs?: Platform_Preview_KickerInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Preview_KickerInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_preview_kicker(inputs)
	return en_platform_preview_kicker(inputs)
});